import BstlArtikel from "@/entities/common/bstl_artikel"
import { AbholzeitType, Terminart } from "@/entities/common/enums"
import BPArtikelHinzufuegenRequest from "@/entities/common/pending/bp_artikel_hinzufuegen_request"
import PlisteProduktZeit, {
  PreislisteKategorie,
  PreislisteProdukt,
} from "@/entities/common/pliste_produkt_zeit"
import RemoteResult from "@/entities/common/remote_result"
import PreislisteZeitraumRequest from "@/entities/common/request/preisliste_zeitpunkt_request"
import router from "@/router"
import ConverterUtil from "@/util/converter_util"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import moment from "moment"
import BaseLogic from "./base_logic"
import vuexStore from "@/store"

export default abstract class ProdukteLogic extends BaseLogic {
  id: any
  preisliste: PlisteProduktZeit = null
  loadError: boolean = false
  insertWorking: boolean = false
  insertError: boolean = false
  artikel: PreislisteProdukt = null
  artikelDialogVisible: boolean = false
  created = false
  selectedKategorie: PreislisteKategorie
  createdListener: () => void

  get hasMindestbestellwert(): boolean {
    return false
  }

  get mindestbestellwert(): number {
    return 0
  }

  get kostenlosAb(): number {
    return 0
  }

  init() {
    var bestellungPending = this.mainLogic.bestellungPending
    var terminart = bestellungPending.terminart
    var datum = null

    if (terminart == Terminart.ABHOLUNG) {
      if (bestellungPending.abholung.abholzeitType == AbholzeitType.BALDEST) {
        datum = moment().format("yyyy-MM-DDTHH:mm:ss")
      } else {
        var u = bestellungPending.abholung.gewaehlteUhrzeit
        datum = u
      }
    } else if (terminart == Terminart.SOFORTBESTELLUNG) {
      datum = moment().format("yyyy-MM-DDTHH:mm:ss")
    } else if (terminart == Terminart.RESERVIERUNG) {
      datum = bestellungPending.reservierung.zeitVon
    } else if (terminart == Terminart.LIEFERUNG) {
      if (bestellungPending.lieferung.abholzeitType == AbholzeitType.BALDEST) {
        datum = moment().format("yyyy-MM-DDTHH:mm:ss")
      } else {
        datum = bestellungPending.lieferung.gewaehlteUhrzeit
      }
    }

    var request = new PreislisteZeitraumRequest()
    request.filialeId = this.filiale.filialeId
    request.zeitpunkt = datum

    this.loadError = false

    Poster.postUser<RemoteResult<PlisteProduktZeit>>(
      RestPaths.artikelPdukteNachZeitSingle,
      request
    )
      .then((response) => {
        if (response.data.success) {
          this.preisliste = response.data.payload
          this.created = true
          if (this.createdListener) {
            this.createdListener()
          }
        } else {
          this.loadError = true
        }
      })
      .catch(() => {
        this.loadError = true
      })
  }

  artikelWaehlen(produkt: PreislisteProdukt): void {
    this.artikel = produkt
    this.artikelDialogVisible = true
  }

  bestellungEinfuegen(): void {
    var terminart = this.mainLogic.bestellungPending.terminart
    if (terminart == Terminart.LIEFERUNG) {
      router.push({ name: RouteNames.NEU.WARENKORB_LIEFERUNG })
    } else {
      router.push({ name: RouteNames.NEU.WARENKORB })
    }
    return
  }

  addArtikel(artikel: BstlArtikel) {
    this.insertWorking = true
    var request = new BPArtikelHinzufuegenRequest()
    request.id = vuexStore.state.user.identifier
    request.artikelData = ConverterUtil.convertBstlArtikel(artikel)

    this.insertError = false

    Poster.postUser<RemoteResult<BstlArtikel>>(
      RestPaths.bestellungpendingArtikelHinzufuegen,
      request
    )
      .then((response) => {
        if (response.data.success) {
          var newArtikel = response.data.payload
          this.mainLogic.bestellungPending.artikelliste.push(newArtikel)
          this.artikel = null
          this.artikelDialogVisible = false
        } else {
          this.insertError = true
        }
        this.insertWorking = false
      })
      .catch(() => {
        this.insertError = true
        this.insertWorking = false
      })
  }

  reloadArtikel(id: string) {
    this.preisliste.kategorien.forEach((kategorie) => {
      kategorie.produkte.forEach((p) => {
        if (p.id == id) {
          this.artikel = p
          return
        }
      })
    })
  }

  highlightCategory(id: any) {}
}
